import type { CellContext } from "@msuite/ui/table";
import type { Tables } from "@msuite/utils/types";

export function RowActions(_props: CellContext<Tables<"serviceCalculationItems">, "actions">) {
	return <></>;
}
